import React from 'react'

const HeaderSocials = () => {
  return (
    <div className="home__socials">
        {/* <a href="https://www.instagram.com/" className="home__social-link" target="_blank">
            <i class="fa-brands fa-instagram"></i>
        </a>

        <a href="https://www.instagram.com/" className="home__social-link" target="_blank">
            <i class="fa-brands fa-twitter"></i>
        </a>

        <a href="https://www.instagram.com/" className="home__social-link" target="_blank">
            <i class="fa-brands fa-behance"></i>
        </a>

        <a href="https://www.instagram.com/" className="home__social-link" target="_blank">
            <i class="fa-brands fa-dribbble"></i>
        </a>

        <a href="https://www.instagram.com/" className="home__social-link" target="_blank">
            <i class="fa-brands fa-pinterest"></i>
        </a> */}
        <a href="https://www.linkedin.com/in/kent-huang1/" className="home__social-link" rel="noopener noreferrer" target="_blank">
            <i class="fa-brands fa-linkedin"></i>
        </a>

        <a href="https://github.com/k521" className="home__social-link" rel="noopener noreferrer" target="_blank">
            <i class="fa-brands fa-github"></i>
        </a>

        <a href="mailto:huang.cw.kent@gmail.com" className="home__social-link" rel="noopener noreferrer" target="_blank">
            <i class="fa-solid fa-envelope"></i>
        </a>


    </div>
  )
}

export default HeaderSocials